/* BASIC APP CONSTANTS */
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const APP_COOKIE_NAME = "APP_COOKIE_NAME";
export const USER_COOKIE_NAME = "USER_COOKIE_NAME";
export const PASS_COOKIE_NAME = "PASS_COOKIE_NAME";
export const USER_ID_COOKIE_NAME = "USER_ID_COOKIE_NAME";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const SET_SIDE_MENU_STATE = "SET_SIDE_MENU_STATE";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const SHOW_ACTION_MENU = "SHOW_ACTION_MENU";
export const HIDE_ACTION_MENU = "HIDE_ACTION_MENU";
export const SHOW_BOTTOM_TOOLBAR = "SHOW_BOTTOM_TOOLBAR";
export const HIDE_BOTTOM_TOOLBAR = "HIDE_BOTTOM_TOOLBAR";
export const SET_USER_LIST = "SET_USER_LIST";
export const EDIT_DISABLED_BUTTONS = "EDIT_DISABLED_BUTTONS";
export const SET_LOGS_LIST = "SET_LOGS_LIST";
export const THEME = "THEME";

/* <---- BASIC APP CONSTANTS ----> */

/* SOCKET CONSTANTS */
export const CONNECTED = "connected";
export const DISCONNECTED = "disconnected";
/* <---- SOCKET CONSTANTS ----> */

/* CONFIGURATION */
export const CONFIGURATION_FORM_TOOGLE_LOADING =
  "CONFIGURATION_FORM_TOOGLE_LOADING";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
/* <---- CONFIGURATION ----> */

/* USER */
export const SET_PROFILE = "SET_PROFILE";
/* <---- USER ----> */

/* USERS */
export const ADD_NEW_USER = "ADD_NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const OPEN_USER_FORM = "OPEN_USER_FORM";
export const CLOSE_USER_FORM = "CLOSE_USER_FORM";
export const EDIT_SELECTED_USER = "EDIT_SELECTED_USER";
export const USERS_FORM_TOOGLE_LOADING = "USERS_FORM_TOOGLE_LOADING";
/* <---- USERS ----> */

/* MAINTENANCE */
export const SET_MAINTENANCE_LIST = "SET_MAINTENANCE_LIST";
export const ADD_NEW_MAINTENANCE = "ADD_NEW_MAINTENANCE";
export const UPDATE_MAINTENANCE = "UPDATE_MAINTENANCE";
export const DELETE_MAINTENANCE = "DELETE_MAINTENANCE";
export const OPEN_MAINTENANCE_FORM = "OPEN_MAINTENANCE_FORM";
export const CLOSE_MAINTENANCE_FORM = "CLOSE_MAINTENANCE_FORM";
export const EDIT_SELECTED_MAINTENANCE = "EDIT_SELECTED_MAINTENANCE";
export const MAINTENANCE_FORM_TOOGLE_LOADING = "MAINTENANCE_FORM_TOOGLE_LOADING";
/* <---- MAINTENANCE ----> */

/* IRREGULARITY */
export const SET_IRREGULARITY_LIST = "SET_IRREGULARITY_LIST";
export const ADD_NEW_IRREGULARITY = "ADD_NEW_IRREGULARITY";
export const UPDATE_IRREGULARITY = "UPDATE_IRREGULARITY";
export const DELETE_IRREGULARITY = "DELETE_IRREGULARITY";
export const OPEN_IRREGULARITY_FORM = "OPEN_IRREGULARITY_FORM";
export const CLOSE_IRREGULARITY_FORM = "CLOSE_IRREGULARITY_FORM";
export const EDIT_SELECTED_IRREGULARITY = "EDIT_SELECTED_IRREGULARITY";
export const IRREGULARITY_FORM_TOOGLE_LOADING = "IRREGULARITY_FORM_TOOGLE_LOADING";
/* <---- IRREGULARITY ----> */

/* IRREGULARITYTYPE */
export const SET_IRREGULARITYTYPE_LIST = "SET_IRREGULARITYTYPE_LIST";
export const ADD_NEW_IRREGULARITYTYPE = "ADD_NEW_IRREGULARITYTYPE";
export const UPDATE_IRREGULARITYTYPE = "UPDATE_IRREGULARITYTYPE";
export const DELETE_IRREGULARITYTYPE = "DELETE_IRREGULARITYTYPE";
export const OPEN_IRREGULARITYTYPE_FORM = "OPEN_IRREGULARITYTYPE_FORM";
export const CLOSE_IRREGULARITYTYPE_FORM = "CLOSE_IRREGULARITYTYPE_FORM";
export const EDIT_SELECTED_IRREGULARITYTYPE = "EDIT_SELECTED_IRREGULARITYTYPE";
export const IRREGULARITYTYPE_FORM_TOOGLE_LOADING = "IRREGULARITYTYPE_FORM_TOOGLE_LOADING";
/* <---- IRREGULARITYTYPE ----> */

/* TIMECHANGEREQUEST */
export const SET_TIMECHANGEREQUEST_LIST = "SET_TIMECHANGEREQUEST_LIST";
export const ADD_NEW_TIMECHANGEREQUEST = "ADD_NEW_TIMECHANGEREQUEST";
export const UPDATE_TIMECHANGEREQUEST = "UPDATE_TIMECHANGEREQUEST";
export const DELETE_TIMECHANGEREQUEST = "DELETE_TIMECHANGEREQUEST";
export const OPEN_TIMECHANGEREQUEST_FORM = "OPEN_TIMECHANGEREQUEST_FORM";
export const CLOSE_TIMECHANGEREQUEST_FORM = "CLOSE_TIMECHANGEREQUEST_FORM";
export const EDIT_SELECTED_TIMECHANGEREQUEST = "EDIT_SELECTED_TIMECHANGEREQUEST";
export const TIMECHANGEREQUEST_FORM_TOOGLE_LOADING = "TIMECHANGEREQUEST_FORM_TOOGLE_LOADING";
/* <---- TIMECHANGEREQUEST ----> */

/* ATTENDANCERECORD */
export const SET_ATTENDANCERECORD_LIST = "SET_ATTENDANCERECORD_LIST";
export const ADD_NEW_ATTENDANCERECORD = "ADD_NEW_ATTENDANCERECORD";
export const UPDATE_ATTENDANCERECORD = "UPDATE_ATTENDANCERECORD";
export const DELETE_ATTENDANCERECORD = "DELETE_ATTENDANCERECORD";
export const OPEN_ATTENDANCERECORD_FORM = "OPEN_ATTENDANCERECORD_FORM";
export const CLOSE_ATTENDANCERECORD_FORM = "CLOSE_ATTENDANCERECORD_FORM";
export const EDIT_SELECTED_ATTENDANCERECORD = "EDIT_SELECTED_ATTENDANCERECORD";
export const ATTENDANCERECORD_FORM_TOOGLE_LOADING = "ATTENDANCERECORD_FORM_TOOGLE_LOADING";
/* <---- ATTENDANCERECORD ----> */

/* HOLIDAY */
export const SET_HOLIDAY_LIST = "SET_HOLIDAY_LIST";
export const ADD_NEW_HOLIDAY = "ADD_NEW_HOLIDAY";
export const UPDATE_HOLIDAY = "UPDATE_HOLIDAY";
export const DELETE_HOLIDAY = "DELETE_HOLIDAY";
export const OPEN_HOLIDAY_FORM = "OPEN_HOLIDAY_FORM";
export const CLOSE_HOLIDAY_FORM = "CLOSE_HOLIDAY_FORM";
export const EDIT_SELECTED_HOLIDAY = "EDIT_SELECTED_HOLIDAY";
export const HOLIDAY_FORM_TOOGLE_LOADING = "HOLIDAY_FORM_TOOGLE_LOADING";
/* <---- HOLIDAY ----> */

/* PERMISSION */
export const SET_PERMISSION_LIST = "SET_PERMISSION_LIST";
export const ADD_NEW_PERMISSION = "ADD_NEW_PERMISSION";
export const UPDATE_PERMISSION = "UPDATE_PERMISSION";
export const DELETE_PERMISSION = "DELETE_PERMISSION";
export const OPEN_PERMISSION_FORM = "OPEN_PERMISSION_FORM";
export const CLOSE_PERMISSION_FORM = "CLOSE_PERMISSION_FORM";
export const EDIT_SELECTED_PERMISSION = "EDIT_SELECTED_PERMISSION";
export const PERMISSION_FORM_TOOGLE_LOADING = "PERMISSION_FORM_TOOGLE_LOADING";
/* <---- PERMISSION ----> */

/* GROUP */
export const SET_GROUP_LIST = "SET_GROUP_LIST";
export const ADD_NEW_GROUP = "ADD_NEW_GROUP";
export const UPDATE_GROUP = "UPDATE_GROUP";
export const DELETE_GROUP = "DELETE_GROUP";
export const OPEN_GROUP_FORM = "OPEN_GROUP_FORM";
export const CLOSE_GROUP_FORM = "CLOSE_GROUP_FORM";
export const EDIT_SELECTED_GROUP = "EDIT_SELECTED_GROUP";
export const GROUP_FORM_TOOGLE_LOADING = "GROUP_FORM_TOOGLE_LOADING";
/* <---- GROUP ----> */

/* APPOINTMENT */
export const SET_APPOINTMENT_LIST = "SET_APPOINTMENT_LIST";
export const ADD_NEW_APPOINTMENT = "ADD_NEW_APPOINTMENT";
export const UPDATE_APPOINTMENT = "UPDATE_APPOINTMENT";
export const DELETE_APPOINTMENT = "DELETE_APPOINTMENT";
export const OPEN_APPOINTMENT_FORM = "OPEN_APPOINTMENT_FORM";
export const CLOSE_APPOINTMENT_FORM = "CLOSE_APPOINTMENT_FORM";
export const EDIT_SELECTED_APPOINTMENT = "EDIT_SELECTED_APPOINTMENT";
export const APPOINTMENT_FORM_TOOGLE_LOADING = "APPOINTMENT_FORM_TOOGLE_LOADING";
export const OPEN_BULK_APPOINTMENT_FORM = "OPEN_BULK_APPOINTMENT_FORM";
export const CLOSE_BULK_APPOINTMENT_FORM = "CLOSE_BULK_APPOINTMENT_FORM";
export const SET_BULK_APPOINTMENT_DATA = "SET_BULK_APPOINTMENT_DATA";
export const SET_MONTHLY_SCHEDULE = "SET_MONTHLY_SCHEDULE";
export const CLEAR_MONTHLY_SCHEDULE = "CLEAR_MONTHLY_SCHEDULE";
export const SET_CURRENT_SCHEDULE_PARAMS = "SET_CURRENT_SCHEDULE_PARAMS";
export const SET_USER_FILTER = "SET_USER_FILTER";
export const CLEAR_USER_FILTER = "CLEAR_USER_FILTER";
/* <---- APPOINTMENT ----> */

/* SHIFTTYPE */
export const SET_SHIFTTYPE_LIST = "SET_SHIFTTYPE_LIST";
export const ADD_NEW_SHIFTTYPE = "ADD_NEW_SHIFTTYPE";
export const UPDATE_SHIFTTYPE = "UPDATE_SHIFTTYPE";
export const DELETE_SHIFTTYPE = "DELETE_SHIFTTYPE";
export const OPEN_SHIFTTYPE_FORM = "OPEN_SHIFTTYPE_FORM";
export const CLOSE_SHIFTTYPE_FORM = "CLOSE_SHIFTTYPE_FORM";
export const EDIT_SELECTED_SHIFTTYPE = "EDIT_SELECTED_SHIFTTYPE";
export const SHIFTTYPE_FORM_TOOGLE_LOADING = "SHIFTTYPE_FORM_TOOGLE_LOADING";
/* <---- SHIFTTYPE ----> */

/* WORKORDER */
export const SET_WORKORDER_LIST = "SET_WORKORDER_LIST";
export const ADD_NEW_WORKORDER = "ADD_NEW_WORKORDER";
export const UPDATE_WORKORDER = "UPDATE_WORKORDER";
export const DELETE_WORKORDER = "DELETE_WORKORDER";
export const OPEN_WORKORDER_FORM = "OPEN_WORKORDER_FORM";
export const CLOSE_WORKORDER_FORM = "CLOSE_WORKORDER_FORM";
export const EDIT_SELECTED_WORKORDER = "EDIT_SELECTED_WORKORDER";
export const WORKORDER_FORM_TOOGLE_LOADING = "WORKORDER_FORM_TOOGLE_LOADING";
/* <---- WORKORDER ----> */

/* INCIDENT */
export const SET_INCIDENT_LIST = "SET_INCIDENT_LIST";
export const ADD_NEW_INCIDENT = "ADD_NEW_INCIDENT";
export const UPDATE_INCIDENT = "UPDATE_INCIDENT";
export const DELETE_INCIDENT = "DELETE_INCIDENT";
export const OPEN_INCIDENT_FORM = "OPEN_INCIDENT_FORM";
export const CLOSE_INCIDENT_FORM = "CLOSE_INCIDENT_FORM";
export const EDIT_SELECTED_INCIDENT = "EDIT_SELECTED_INCIDENT";
export const INCIDENT_FORM_TOOGLE_LOADING = "INCIDENT_FORM_TOOGLE_LOADING";
/* <---- INCIDENT ----> */

/* ROLE */
export const SET_ROLE_LIST = "SET_ROLE_LIST";
export const ADD_NEW_ROLE = "ADD_NEW_ROLE";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const DELETE_ROLE = "DELETE_ROLE";
export const OPEN_ROLE_FORM = "OPEN_ROLE_FORM";
export const CLOSE_ROLE_FORM = "CLOSE_ROLE_FORM";
export const EDIT_SELECTED_ROLE = "EDIT_SELECTED_ROLE";
export const ROLE_FORM_TOOGLE_LOADING = "ROLE_FORM_TOOGLE_LOADING";
/* <---- ROLE ----> */

/* LOCATION */
export const SET_LOCATION_LIST = "SET_LOCATION_LIST";
export const ADD_NEW_LOCATION = "ADD_NEW_LOCATION";
export const UPDATE_LOCATION = "UPDATE_LOCATION";
export const DELETE_LOCATION = "DELETE_LOCATION";
export const OPEN_LOCATION_FORM = "OPEN_LOCATION_FORM";
export const CLOSE_LOCATION_FORM = "CLOSE_LOCATION_FORM";
export const EDIT_SELECTED_LOCATION = "EDIT_SELECTED_LOCATION";
export const LOCATION_FORM_TOOGLE_LOADING = "LOCATION_FORM_TOOGLE_LOADING";
/* <---- LOCATION ----> */

/* EQUIPMENT */
export const SET_EQUIPMENT_LIST = "SET_EQUIPMENT_LIST";
export const ADD_NEW_EQUIPMENT = "ADD_NEW_EQUIPMENT";
export const UPDATE_EQUIPMENT = "UPDATE_EQUIPMENT";
export const DELETE_EQUIPMENT = "DELETE_EQUIPMENT";
export const OPEN_EQUIPMENT_FORM = "OPEN_EQUIPMENT_FORM";
export const CLOSE_EQUIPMENT_FORM = "CLOSE_EQUIPMENT_FORM";
export const EDIT_SELECTED_EQUIPMENT = "EDIT_SELECTED_EQUIPMENT";
export const EQUIPMENT_FORM_TOOGLE_LOADING = "EQUIPMENT_FORM_TOOGLE_LOADING";
/* <---- EQUIPMENT ----> */

/* ROUTES */
export const SET_ALL_ROUTES = "SET_ALL_ROUTES";
export const UPDATE_ROUTE = "UPDATE_ROUTE";
/* <---- ROUTES ----> */

/* ALERT */
export const SET_ALERT_LIST = "SET_ALERT_LIST";
export const ADD_NEW_ALERT = "ADD_NEW_ALERT";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const OPEN_ALERT_FORM = "OPEN_ALERT_FORM";
export const CLOSE_ALERT_FORM = "CLOSE_ALERT_FORM";
export const EDIT_SELECTED_ALERT = "EDIT_SELECTED_ALERT";
export const ALERT_FORM_TOOGLE_LOADING = "ALERT_FORM_TOOGLE_LOADING";
/* <---- ALERT ----> */
